import { render, staticRenderFns } from "./ModalEditPaillette.vue?vue&type=template&id=eb062c34&"
import script from "./ModalEditPaillette.vue?vue&type=script&lang=js&"
export * from "./ModalEditPaillette.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports